<script lang="ts">
export default {
  name: 'KkListWithMenu',
}
</script>

<script setup lang="ts">
import { KkIcon } from '../../../components/base'

// NOTE: 今のところmapionBiz周りでしか使われていなさそうだが、汎用的に使うには修正が必要
type MenuType = 'edit' | 'moveTop' | 'moveOneUp' | 'moveOneDown' | 'moveBottom' | 'delete';

interface MenuItem {
  type: MenuType;
  text: string;
}

interface Props {
  menuList: MenuItem[];
  open: boolean;
}

interface Emits {
  (key: 'on-click-edit-menu', type: MenuType): void
  (key: 'open'): void
  (key: 'close'): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()

const handleEditMenu = (type: MenuType) => {
  emits('on-click-edit-menu', type)
  closeDropdown()
}
const closeDropdown = () => {
  emits('close')
}
</script>
<template>
  <div class="box">
    <div class="content">
      <slot />
    </div>

    <div class="menu">
      <div class="menu__editButton">
        <button type="button" @click="emits('open')">
          <KkIcon name="iconVerticalThreePointLeader" />
        </button>
        <ul v-show="props.open" class="menu__editList">
          <li v-for="menu in props.menuList"
              :key="menu.type"
              class="menu__editListItem"
              @click="handleEditMenu(menu.type)"
          >
            {{ menu.text }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="props.open" class="bg" @click="closeDropdown()" />
  </div>
</template>

<style lang="scss" scoped>
.box {
  display: flex;
  padding: 24px;
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__title {
    width: 100%;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 16px;
  }
}

.menu {
  width: 5%;
  display: flex;
  &__editButton {
    display: flex;
    cursor: pointer;
    position: relative;
  }

  &__editList {
    position: absolute;
    width: 240px;
    background: white;
    box-shadow: 0 1px 4px rgb(0 0 0 / 26%);
    padding: 10px 0;
    z-index: 1;
    right: 100%;
  }

  &__editListItem{
    margin-bottom: 5px;
    padding: 15px 24px;
    &:hover {
      background-color: rgba(0,0,0,.1);
      cursor: pointer;
    }
  }
}

.content {
  width: 95%;
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
